angular.module("vgresiduos").controller("ClientFormProductionCtrl", [
	"$scope",
	"permissionService",
	function ($scope, permissionService) {
		"use strict";

		$scope.editPermission = permissionService.hasPermissionV2(Vgr.systemPermissions.EditUnit, $scope.clientId);
	}
]);
